import React, { Fragment } from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import moment from "moment";
import {
    Grid,
    Chip,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Fab,
    TableCell,
    TableRow,
    TableContainer,
    Box,
    Collapse,
    Paper,
    TableBody,
    TablePagination,
    Tooltip,
    Table,
    TableHead,
    Zoom
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import IconButton from '@material-ui/core/IconButton';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SelectClient from "common/components/custom/SelectClient";
import SelectInventory from "common/components/custom/SelectInventory"
import { getSpecificClients } from "views/clients/api/apiClients";
import { getInventorySimple } from "views/inventory/api/apiInventory";
import SortingAndFiltering from "common/components/custom/SortingAndFiltering"
import { getEmployeeHistory } from "views/asset/api/apiAsset";
import { getLocationHistory } from "views/asset/api/apiAsset";
import { getAssets, changeActiveStatus } from "views/asset/api/apiAsset";
import DepreciationRateDetailsDialog from "views/asset/components/rate/DepreciationRateDetailsDialog";
import AssetEmployeeHistoryDialog from "views/asset/components/asset/AssetEmployeeHistoryDialog";
import AssetLocationHistoryDialog from "views/asset/components/asset/AssetLocationHistoryDialog";
import ConfirmationDialog from "common/components/ConfirmationDialog";

class InactiveAssets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            selectedClient: null,
            client: props.location.state && props.location.state.selectedClient ? props.location.state.selectedClient : null,
            selectedInventory: props.location.state && props.location.state.selectedInventory ? props.location.state.selectedInventory : null,
            inventories: [],
            assets: [],
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25,
            collapseIndex: -1,
            dialogRate: false,
            assetId: null,
            filter: '',
            depreciationRates: [],
            historyEmployeeDialog: false,
            historyLocationDialog: false,
            employeesHistory: [],
            locationsHistory: [],
            selectedFrom: moment(new Date()).startOf('month'),
            selectedTo: moment(new Date()).endOf('month').add(1, 'days'),
            assetIsActive: null,
            dialogOpen: false
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getAssets(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getAssets(this.state.activePage, this.state.selectedClient.id))
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.state !== this.state.locationState) {
            this.setState({ locationState: prevProps.location.state }, () => this.state.locationState !== undefined ? this.getAssets(0, this.state.selectedInventory.id) : null)
        }
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = this.state.client !== null ? this.state.client : response.data.data.length === 0 ? null : response.data.data[0]
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getInventorySimple(selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getInventorySimple = (selectedClient) => {
        getInventorySimple(selectedClient).then((response) => {
            this.setState({ inventories: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getAssets = (page, inventoryId) => {
        let requestBody = {
            depreciationFrom: moment(this.state.selectedFrom, 'DD-MM-YYYY').format("DD-MM-YYYY"),
            depreciationTo: moment(this.state.selectedTo, 'DD-MM-YYYY').format("DD-MM-YYYY")
        }
        getAssets({
            params: {
                inventoryId: inventoryId,
                page: page,
                size: this.state.rowsPerPage,
                sort: this.state.filter.sort !== "" ? this.state.filter.sort : null,
                isActive: false
            }
        }, requestBody).then((response) => {
            this.setState({
                assets: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_inactive_assets"), { variant: 'error' });
        });
    }

    changeActiveStatus = () => {
        changeActiveStatus({ params: { isActive: !this.state.assetIsActive } }, this.state.assetId).then(response => {
            this.props.enqueueSnackbar(this.props.t("success_move_to_fixed_assets", { assetName: this.state.assetName }), { variant: 'success' });
            this.setState({ dialogOpen: false, rowsPerPage: this.state.rowsPerPage }, () => this.getAssets(0, this.state.selectedInventory.id));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_change_active_status"), { variant: 'error' });
        })
    }

    handleChangeClient = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client, selectedInventory: null }, () => this.getInventorySimple(client.id))
        } else {
            this.setState({ selectedClient: null, selectedInventory: null })
        }
    }

    handleChangeInventory = (inventory) => {
        if (inventory !== null) {
            this.setState({ selectedInventory: inventory, isLoading: true }, () => this.getAssets(0, this.state.selectedInventory.id))
        } else {
            this.setState({ selectedInventory: null, assets: [], totalElements: 0 })
        }
    }

    closeDialog = () => {
        this.setState({ dialogRate: false, assetId: null, depreciationRates: [] });
    }

    closeDialogEmployeeHistory = () => {
        this.setState({ historyEmployeeDialog: false })
    }

    closeDialogLocationHistory = () => {
        this.setState({ historyLocationDialog: false })
    }


    getEmployeeHistory = (asset) => {
        this.setState({ assetId: asset.id })
        getEmployeeHistory(asset.id).then(response => {
            this.setState({ employeesHistory: response.data.data, historyEmployeeDialog: true, assetName: asset.standardAttr.assetName, inventoryNumber: asset.standardAttr.assetInventoryNumber });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_employee_history"), { variant: 'error' });
        });
    }

    getLocationHistory = (asset) => {
        this.setState({ assetId: asset.id })
        getLocationHistory(asset.id).then(response => {
            this.setState({ locationsHistory: response.data.data, historyLocationDialog: true, assetName: asset.standardAttr.assetName, inventoryNumber: asset.standardAttr.assetInventoryNumber });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_location_history"), { variant: 'error' });
        });
    }


    render() {

        let { isLoading, totalElements, selectedClient, specificsClients, selectedInventory, inventories, assets, collapseIndex, filter, selectedFrom, selectedTo, assetId, dialogRate, depreciationRates, dialogOpen } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let assetsList;
        let recordsNotFound;
        if (assets && assets.length > 0) {
            assetsList = assets.map((asset, index) => {
                return <Fragment key={index}>
                    <TableRow hover className={index === this.state.collapseIndex ? 'table-custom-header-background' : null}>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>
                            <IconButton aria-label="expand row" size="small" onClick={() => this.setState({ open: !this.state.open, collapseIndex: collapseIndex !== index ? index : -1 })}>
                                {index === collapseIndex ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>
                            <Tooltip interactive disableFocusListener disableTouchListener transitioncomponent={Zoom} arrow title={<div style={{ fontSize: '14px' }}>
                                <p><b>{this.props.t("account_group")}:</b> {asset.depreciationGroup && asset.depreciationGroup.accountGroup}</p>
                                <p><b>{this.props.t("regular_rate")}:</b> {asset.depreciationGroup && asset.depreciationGroup.regularRate}</p>
                                <p><b>{this.props.t("accelerated_rate")}:</b> {asset.depreciationGroup && asset.depreciationGroup.acceleratedRate}</p>
                            </div>}>
                                <span>{asset.depreciationGroup && asset.depreciationGroup.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>{asset.standardAttr.assetName}</TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>{asset.standardAttr.assetInventoryNumber}</TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.standardAttr.purchaseAmount} /></TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountRequestFrom} /></TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountTimePeriod} /></TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell-1' : "custom-table-cell-numbers"}><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountAfterPeriod} /></TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>{asset.assetAccount && asset.assetAccount.account}</TableCell>
                        <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null} >{asset.contraAssetAccount && asset.contraAssetAccount.account}</TableCell>
                        <TableCell>{asset.standardAttr.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                        <TableCell>
                            <Fab title={this.props.t("change_active_status")} onClick={() => this.setState({ dialogOpen: true, assetId: asset.id, assetIsActive: asset.standardAttr.isActive, assetName: asset.standardAttr.assetName })} size="small" color="inherit" aria-label="change-active-status">
                                <RestoreFromTrashIcon />
                            </Fab>
                        </TableCell>
                    </TableRow >
                    <TableRow className={index === this.state.collapseIndex ? 'table-custom-body-background' : null}>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: "none" }} colSpan={12}>
                            <Collapse in={index === this.state.collapseIndex} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                    <Table aria-label="simple table" size="small" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("amount_start_of_year")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("monthly_amount")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("rate")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("residual_value")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.amountStartOfYear} /></TableCell>
                                                <TableCell><NumberFormat displayType="text" decimalScale={6} fixedDecimalScale={true} thousandSeparator={true} value={asset.depreciationAttr.currentMonthlyAmount} /></TableCell>
                                                <TableCell className={index === this.state.collapseIndex ? 'custom-table-cell' : null}>
                                                    <Chip color="primary" label={<><span style={{ verticalAlign: 'super', padding: '10px' }}>{asset.depreciationAttr.currentRate}</span><ZoomInIcon /></>} onClick={() => this.setState({ dialogRate: true, assetId: asset.id, depreciationRates: asset.depreciationRates })} />
                                                </TableCell>
                                                <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={asset.standardAttr.residualValue} /></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Table aria-label="simple table" size="small" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("purchase_date")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("commissioning_date")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("end_date")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("total_months")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell>{asset.standardAttr.dateOfPurchase}</TableCell>
                                                <TableCell>{asset.depreciationAttr.dateOfCommissioning}</TableCell>
                                                <TableCell>{asset.depreciationAttr.endDate}</TableCell>
                                                <TableCell>{asset.depreciationAttr.totalMonths}</TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Table aria-label="simple table" size="small" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("project")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("cost_centre")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("cost_account")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("inpreparation_account")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell>{asset.standardAttr.project}</TableCell>
                                                <TableCell>{asset.standardAttr.costCentre}</TableCell>
                                                <TableCell>{asset.costAccount && asset.costAccount.account}</TableCell>
                                                <TableCell>{asset.inpreparationAccount && asset.inpreparationAccount.account}</TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Table aria-label="simple table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("quantity")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("employee")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("location")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("vendor")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("in_use")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="15%">{this.props.t("note")}</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow hover>
                                                <TableCell>{asset.standardAttr.quantity}</TableCell>
                                                <TableCell>
                                                    <Tooltip interactive disableFocusListener disableTouchListener arrow transitioncomponent={Zoom} title={asset.employee !== null ? <div style={{ fontSize: '14px' }} >
                                                        <p><b>{this.props.t("first_name")}: </b> {asset.employee && asset.employee.firstName}</p>
                                                        <p><b>{this.props.t("last_name")}: </b> {asset.employee && asset.employee.lastName}</p>
                                                    </div> : <div></div>}>
                                                        <Chip color="primary" label={<><span style={{ verticalAlign: 'super', padding: '10px' }}>{asset.employee === null ? this.props.t("not_assigned") : asset.employee.email}</span><ZoomInIcon /></>} onClick={() => this.getEmployeeHistory(asset)} />
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip interactive disableFocusListener disableTouchListener arrow transitioncomponent={Zoom} title={asset.location !== null ? <div style={{ fontSize: '14px' }} >
                                                        <p><b>{this.props.t("floor")}:</b> {asset.location && asset.location.floor}</p>
                                                        <p><b>{this.props.t("room")}:</b> {asset.location && asset.location.room}</p>
                                                        <p><b>{this.props.t("city")}:</b> {asset.location && asset.location.city}</p>
                                                        <p><b>{this.props.t("postal_code")}:</b> {asset.location && asset.location.postalCode}</p>
                                                    </div> : <div></div>}>
                                                        <Chip color="primary" label={<><span style={{ verticalAlign: 'super', padding: '10px' }}>{asset.location === null ? this.props.t("not_assigned") : asset.location.address}</span><ZoomInIcon /></>} onClick={() => this.getLocationHistory(asset)} />
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip interactive disableFocusListener disableTouchListener arrow transitioncomponent={Zoom} title={<div style={{ fontSize: '14px' }} >
                                                        <p><b>{this.props.t("address")}:</b> {asset.vendor && asset.vendor.address}</p>
                                                        <p><b>{this.props.t("city")}:</b> {asset.vendor && asset.vendor.city}</p>
                                                        <p><b>{this.props.t("postal_code")}:</b> {asset.vendor && asset.vendor.postalCode}</p>
                                                    </div>}>
                                                        <span>{asset.vendor && asset.vendor.name}</span>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>{asset.standardAttr.isInUse ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                                                <TableCell>{asset.standardAttr.note}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </Fragment>
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("inactive_assets") + " (" + totalElements + ")"} />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={5} md={5} lg={4} xl={4}>
                                        <SelectClient
                                            specificsClients={specificsClients}
                                            selectedClient={selectedClient}
                                            handleChange={this.handleChangeClient}
                                        />
                                    </Grid>
                                    {selectedClient !== null && <Grid item container direction="column" xs={6} sm={5} md={5} lg={4} xl={4}>
                                        <Grid item container>
                                            <SelectInventory
                                                inventories={inventories}
                                                selectedInventory={selectedInventory}
                                                handleChange={this.handleChangeInventory}
                                            />
                                        </Grid>
                                    </Grid>}
                                </Grid>
                            </Grid>
                        </Grid>
                        {assets && assets.length > 0 && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <SortingAndFiltering columns={[
                                                    {
                                                        name: '',
                                                        width: '5%',
                                                    },
                                                    {
                                                        name: this.props.t("depreciation_group"),
                                                        width: '10%'
                                                    },
                                                    {
                                                        name: this.props.t("name"),
                                                        dbName: 'asset_name',
                                                        width: '15%',
                                                        sort: true
                                                    },
                                                    {
                                                        name: this.props.t("inventory_number"),
                                                        dbName: 'asset_inventory_number',
                                                        width: '10%',
                                                        sort: true
                                                    },
                                                    {
                                                        name: this.props.t("purchase_amount"),
                                                        align: 'right',
                                                        sort: false,
                                                        width: '10%'
                                                    },
                                                    {
                                                        name: this.props.t("previous_depreciation"),
                                                        align: 'right',
                                                        width: '10%'
                                                    },
                                                    {
                                                        name: this.props.t("amount_time_period"),
                                                        align: 'right',
                                                        width: '10%'
                                                    },
                                                    {
                                                        name: this.props.t("amount_after_period"),
                                                        align: 'right',
                                                        width: '10%'
                                                    },
                                                    {
                                                        name: this.props.t("account"),
                                                        width: '5%'
                                                    },
                                                    {
                                                        name: this.props.t("contra_account"),
                                                        width: '5%'
                                                    },
                                                    {
                                                        name: this.props.t("active"),
                                                        width: '5%'
                                                    },
                                                    {
                                                        name: '',
                                                        width: '5%'
                                                    }
                                                ]}
                                                    filter={filter}
                                                    onSortChange={(sort) => this.setState({ filter: { ...this.state.filter, sort: sort }, page: 0 }, () => this.getAssets(0, this.state.selectedInventory.id))}
                                                />
                                                <TableBody>
                                                    {assetsList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>
            </Grid>
            <DepreciationRateDetailsDialog
                isOpen={dialogRate}
                onClose={this.closeDialog}
                assetId={assetId}
                history={this.props.history}
                depreciationRates={depreciationRates}
                selectedFrom={moment(selectedFrom).format("DD-MM-YYYY")}
                selectedTo={moment(selectedTo).format("DD-MM-YYYY")}
                selectedClient={selectedClient}
                selectedInventory={selectedInventory}
                selectedRadioButton={this.state.selectedRadioButton}
                inactiveAssets={true}
            />
            <AssetEmployeeHistoryDialog
                isOpen={this.state.historyEmployeeDialog}
                onClose={this.closeDialogEmployeeHistory}
                employeesHistory={this.state.employeesHistory}
                assetName={this.state.assetName}
                history={this.props.history}
                assetId={assetId}
                selectedClient={selectedClient}
                selectedInventory={selectedInventory}
                inventoryNumber={this.state.inventoryNumber}
                selectedFrom={moment(selectedFrom).format("DD-MM-YYYY")}
                selectedTo={moment(selectedTo).format("DD-MM-YYYY")}
                selectedRadioButton={this.state.selectedRadioButton}
                inactiveAssets={true}
            />
            <AssetLocationHistoryDialog
                isOpen={this.state.historyLocationDialog}
                onClose={this.closeDialogLocationHistory}
                locationsHistory={this.state.locationsHistory}
                assetName={this.state.assetName}
                history={this.props.history}
                assetId={assetId}
                selectedClient={selectedClient}
                selectedInventory={selectedInventory}
                inventoryNumber={this.state.inventoryNumber}
                selectedFrom={moment(selectedFrom).format("DD-MM-YYYY")}
                selectedTo={moment(selectedTo).format("DD-MM-YYYY")}
                selectedRadioButton={this.state.selectedRadioButton}
                inactiveAssets={true}
            />
            <ConfirmationDialog
                isOpen={dialogOpen}
                title={this.props.t("change_active_status")}
                message={this.props.t("message_remove_from_recycling_bin", { assetName: this.state.assetName })}
                onClose={() => this.setState({ dialogOpen: false })}
                onConfirm={() => this.setState({ dialogOpen: false }, () => this.changeActiveStatus())}
                closeButtonTitle={this.props.t("close")}
                confirmButtonTitle={this.props.t("move")}
            />

        </Grid >
    }
}

export default withSnackbar(withTranslation()(InactiveAssets))